import RecoverStep from "../recover_step";

const TEMPLATE = 'error';

export default class ErrorStep extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    postRender(data, el, fr) {
        $(el).find('#contact_support a').on('click', function () {
            fr.callMethod("transitionContactSupport");
        });
    }

    transitionContactSupport(data, el, fr) {
        data.render = {assistance_needed: true};
        fr.goTo('notAvailable');
    }

    transitionBack(data, el, fr) {
        fr.goTo(data.tmp.previousStep);
    }
}
